import { IBrandRoutes } from './types';

const brandRoutes: IBrandRoutes = {};

export default brandRoutes;
